export default {
  allIn: 'allIn',
  manualProcess: 'manualProcess',
};
